import { useBlockProps, RichText } from '@wordpress/block-editor';

export default function save(props) {
	const { attributes } = props;
	const { content } = attributes;
	const blockProps = useBlockProps.save({
		className: 'c4l-expected-feedback'
	});
	return (
		<div {...blockProps}>
			<RichText.Content
				tagName='div'
				className='c4l-expected-feedback-content'
				value={content}
			/>
		</div>
	);
}
